import React, { useState } from "react";
import { Calendar } from "@opendate-app/setlist";

import { fromIsoDate, toIsoDate } from "../Broadcasts/broadcastIndexConfig";

const DateRangeEditor = ({ values, onChange, close }) => {
  const [range, setRange] = useState(() => (
    values.length === 2 ? { start: fromIsoDate(values[0]), end: fromIsoDate(values[1]) } : null
  ));

  const handleChange = (next) => {
    setRange(next);
    if (!next?.start || !next?.end) return;
    onChange([toIsoDate(next.start), toIsoDate(next.end)]);
    close();
  };

  return <Calendar mode="range" value={range} onChange={handleChange} />;
};

export const formatDateRange = (values) => {
  const format = (iso) => fromIsoDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  return values[0] === values[1] ? format(values[0]) : `${format(values[0])} – ${format(values[1])}`;
};

export default DateRangeEditor;
